import Tab from "react-bootstrap/Tab";
import React from "react";

import PreFrecuentes from "./../../datos/json/preguntasFrecuentes.json";
import { Panel, PanelGroup } from "rsuite";

//*interfaces
interface PropsMenuV {
  menu: any;
}

export default function ParteContenido(props: PropsMenuV) {
  let menu = props.menu;
  let rutaNAS = process.env.REACT_APP_DOCS;
  return (
    <div id="idcont">
      <Tab.Content>
        {menu.map((item: any, key: any) => (
          <Tab.Pane eventKey={item.id}>
            {" "}
            <span className="colorBlue2">{item.desc}</span>
            <br />            
              {item.img !== "" ? (
                  <>   
                  <a href={rutaNAS+item.archivo} target="_blank" rel="noreferrer">                        
                    {item.id == "1" && <div className="imagenUsuario" title="Descarga archivo"></div>} {/*  //manual de usuario.pdf */}
                    {item.id == "2" && <div className="imagenGestion" title="Descarga archivo"></div>} {/* //gestion d cambios.ptdf */}
                    {item.id == "4" && <div className="imagenGuia" title="Descarga archivo"></div>} {/*//guia rapida para el uso */}
                  </a>  
                  </>
              ) : (
                <>
                  <br />
                  <div className="panel" id="ayuda">
                    <PanelGroup accordion bordered >
                      {PreFrecuentes.map((s, key) => (
                        <Panel header={s.text} eventKey={s.id} id={s.id} >
                          {PreFrecuentes[s.id].ques.map((data, key) => {
                           // console.log("key...",key);
                            return (
                              <div key={key}>
                                {data.q}
                                <br />
                                <div key={key} className="resp">
                                  <span  dangerouslySetInnerHTML={{ __html: data.r }}></span>
                                  <br />
                                </div>
                              </div>
                            );
                          })}
                        </Panel>
                      ))}{" "}
                    </PanelGroup>
                  </div>
                  <br />
            
                </>
              )}
            
            <br />
             {/* //imagenes que no muestran el descargar */}
             {item.img !== "" && (key != 2) ? (
                  <>               
                  <a href={rutaNAS+item.archivo} target="_blank" rel="noreferrer">
                    <div  title="Descarga archivo"><span className="colorDetalle ">Descargar {item.desc}</span></div>                    
                  </a></>
                ): (
                  ""
                )}
          
          </Tab.Pane>
        ))}
      </Tab.Content>
    </div>
  );
}
